import { Box, Button, Container, Flex, Text } from '@chakra-ui/react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import ArrowIcon from '@/assets/icons/ic-arrow.svg';

export const BottomLine = () => {
  const { t } = useTranslation();

  return (
    <Box bgColor="gray.900" p={12} textAlign="center">
      <Container maxW="1000px">
        <Flex color="white" flexDirection="column" alignItems="center" margin="auto">
          <Text fontSize="3xl" fontFamily="heading" fontWeight="bold">
            {t('audioVisualPage.theBottomLineHeading')}
          </Text>
          <Text mt={4}>{t('audioVisualPage.theBottomLineDescription')}</Text>
          <Button
            as={Link}
            href="/contact-us/conferences"
            variant="solid"
            alignSelf="center"
            mt={8}
            rightIcon={<ArrowIcon />}
          >
            {t('newEventPage.getStarted')}
          </Button>
        </Flex>
      </Container>
    </Box>
  );
};
